<template>
    <header
        class="AlgoliaSearchHeader"
    >
        <BreadCrumbs current="Search" />

        <div class="container">
            <BaseHeading
                preheading="Searching for:"
            />

            <AlgoliaSearchBar
                class="AlgoliaSearchBar"
            />

            <AlgoliaSearchLocations @update="update"/>

            <BaseModal
                :image="image || null"
                :ratio="ratio || null"
            >
            </BaseModal>
        </div>
    </header>
</template>
<script>
export default {
    name: 'AlgoliaSearchHeader',
    props: {
        image: {
            type: String,
            default: null
        },
        ratio: {
            type: Number,
            default: null
        }
    },
    methods: {
        update(value) {
            this.$emit('update', value);
        },
    },
}
</script>
<style lang="scss">
    .AlgoliaSearchHeader {
        background: getColor('white', 'dirty');
        padding-top: getSpacing(small);
        padding-bottom: getSpacing(large);

        @include media-query(palm) {
            padding-bottom: getSpacing(medium);
            background: getColor('white');
        }
    }

    .AlgoliaSearchHeader > .container {
        @include media-query(lap-and-up) {
            display: flex;
            align-items: flex-end;

            > * {
                flex-grow: 1;
            }
        }

        @include media-query(desk) {
            align-items: flex-start;
        }
    }

    .AlgoliaSearchHeader .BaseHeading {
        @include media-query(palm) {
            padding-bottom: getSpacing(base);
        }
        @include media-query(lap) {
            padding-right: getSpacing(medium);
            width: 240px;
        }
        @include media-query(desk) {
            padding-right: 2rem;
            width: 350px;
        }
    }

    .AlgoliaSearchBar, .AlgoliaSearchLocations {
        @include media-query(lap-and-up) {
            width: 48%!important;
        }
    }

    .AlgoliaSearchLocations {
        @include media-query(palm) {
            margin-top: getSpacing(base);
            width: 70%;
            display: inline-block;
            vertical-align: middle;
        }
    }

    .AlgoliaSearchHeader .BaseModal {
        padding-left: getSpacing(medium);

        @include media-query(palm) {
            margin-top: getSpacing(base);
            width: calc(30% - 2rem);
            display: inline-block;
            vertical-align: middle;
            font-size: 16px;
            text-align: right;
        }
    }
</style>
